// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Assignment from "@material-ui/icons/Assignment";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';

// core components/views for Admin layout
import DashboardPage from "views/DashboardOperator/DashboardOperator.js";
import TableListOperator from "views/TableListOperator/TableListOperator.js";
import ClientsOperator from "views/ClientsOperator/ClientsOperator.js";
import RoutesOfDelivery from "views/RoutesOfDelivey/RoutesOfDelivety";
import BatchToCar from "views/BatchToCar/BatchToCar";
import Cars from "views/Cars/Cars";
import Sell from "views/SellOperator/SellOperator.js";
import Order from "views/OrderOperator/OrderOperator.js";
import Report from "views/ReportOperator/ReportOperator.js";
import ReceiptIcon from '@material-ui/icons/Receipt';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import DataUsage from '@material-ui/icons/DataUsage';
import Region from "views/Region/Region";

const dashboardRoutes = [
  /* {
     path: "/dashboard",
     name: "Início",
     icon: Dashboard,
     component: DashboardPage,
     layout: "/operator"
   },*/
  {
    path: "/table",
    name: "Entradas",
    icon: "content_paste",
    component: TableListOperator,
    layout: "/operator"
  },
  {
    path: "/sell",
    name: "Vendas",
    icon: "payments",
    component: Sell,
    layout: "/operator"
  },
  {
    path: "/order",
    name: "Pedidos",
    icon: ReceiptIcon,
    component: Order,
    layout: "/operator"
  },
  {
    path: "/reports",
    name: "Relatórios",
    icon: Assignment,
    component: Report,
    layout: "/operator"
  },
  {
    path: "/clients",
    name: "Clientes",
    icon: AssignmentInd,
    component: ClientsOperator,
    layout: "/operator"
  },
  {
    path: "/region",
    name: "Região",
    icon: LocationSearchingIcon,
    component: Region,
    layout: "/operator",
  },
  /*{
    path: "/routes",
    name: "Rotas",
    icon: AssignmentInd,
    component: RoutesOfDelivery,
    layout: "/operator"
  },
  {
    path: "/cars",
    name: "Carros",
    icon: DirectionsCar,
    component: Cars,
    layout: "/operator"
  },
  {
    path: "/batch-to-car",
    name: "Divisão de carga",
    icon: DataUsage,
    component: BatchToCar,
    layout: "/operator"
  },*/
];

export default dashboardRoutes;
